var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link"},[_c('router-link',{attrs:{"to":_vm.getStoryblokLink(_vm.menuItem.link)},domProps:{"innerHTML":_vm._s(_vm.menuItem.title)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }